"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CrossIcon = exports.EmailIcon = exports.GreenCircularTick = exports.BackArrow = exports.CrossInsideCircle = exports.TickMark = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var TickMark = function TickMark(_ref) {
  var width = _ref.width,
      color = _ref.color;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 16 11",
    style: {
      width: width
    }
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(-27 -1804)"
  }, _react.default.createElement("g", {
    stroke: color ? color : '#33cc99',
    transform: "translate(29 1806)"
  }, _react.default.createElement("polyline", {
    strokeWidth: "3",
    points: "0 3.3518 4.044 7.5 12 0"
  }))));
};

exports.TickMark = TickMark;

var CrossInsideCircle = function CrossInsideCircle(_ref2) {
  var width = _ref2.width,
      color = _ref2.color;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: width,
      cursor: 'pointer'
    },
    version: "1.1",
    viewBox: "0 0 26 26"
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    transform: "translate(-800 -770)"
  }, _react.default.createElement("g", {
    stroke: color ? color : '#f15252',
    strokeWidth: "2",
    transform: "translate(801 771)"
  }, _react.default.createElement("path", {
    d: "m11.692 23.385c6.4572 0 11.692-5.2351 11.692-11.692 0-6.4572-5.2351-11.692-11.692-11.692-6.4572 0-11.692 5.2351-11.692 11.692 0 6.4572 5.2351 11.692 11.692 11.692z"
  }), _react.default.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(7.2 7.2)"
  }, _react.default.createElement("path", {
    d: "m0 0 9.6 9.6"
  }), _react.default.createElement("path", {
    d: "M9.6,0 L0,9.6"
  })))));
};

exports.CrossInsideCircle = CrossInsideCircle;

var BackArrow = function BackArrow(_ref3) {
  var width = _ref3.width;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: width,
      cursor: 'pointer'
    },
    version: "1.1",
    viewBox: "0 0 14 11"
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, _react.default.createElement("g", {
    fillRule: "nonzero",
    stroke: "#484848",
    transform: "translate(-28 -90)"
  }, _react.default.createElement("g", {
    transform: "translate(29 90)"
  }, _react.default.createElement("polyline", {
    points: "5 0 0 5.4615 5 11"
  }), _react.default.createElement("path", {
    d: "m0.30034 5.5967h11.5"
  })))));
};

exports.BackArrow = BackArrow;

var GreenCircularTick = function GreenCircularTick(_ref4) {
  var width = _ref4.width,
      color = _ref4.color;
  return _react.default.createElement("svg", {
    version: "1.1",
    style: {
      width: width
    },
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    transform: "translate(-27 -1150)",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, _react.default.createElement("g", {
    transform: "translate(28 1151)",
    stroke: color ? color : '#33cc99'
  }, _react.default.createElement("path", {
    d: "m9.8852 19.487c5.381 0 9.7436-4.3626 9.7436-9.7436 0-5.381-4.3626-9.7436-9.7436-9.7436-5.381 0-9.7436 4.3626-9.7436 9.7436 0 5.381 4.3626 9.7436 9.7436 9.7436z",
    strokeWidth: "2.0103"
  }), _react.default.createElement("polyline", {
    points: "5.8501 9.4248 8.6152 12.261 14.055 7.133",
    strokeLinejoin: "round",
    strokeWidth: "2.0513"
  }))));
};

exports.GreenCircularTick = GreenCircularTick;

var EmailIcon = function EmailIcon(_ref5) {
  var width = _ref5.width,
      color = _ref5.color;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: width
    },
    version: "1.1",
    viewBox: "0 0 18 14"
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    stroke: color ? color : '#a0a0a0',
    transform: "translate(-791 -760)"
  }, _react.default.createElement("g", {
    transform: "translate(790 757)"
  }, _react.default.createElement("g", {
    transform: "translate(1 4)"
  }, _react.default.createElement("path", {
    d: "m1.4261 0c-0.43561 0-0.79457 0.39153-0.79457 0.86667v9.8222c0 0.47514 0.35896 0.86667 0.79457 0.86667h14.832c0.43561 0 0.79457-0.39153 0.79457-0.86667v-9.8222c0-0.47514-0.35896-0.86667-0.79457-0.86667h-14.832z"
  }), _react.default.createElement("polyline", {
    points: "0.63158 0.88889 8.8421 7.1111 17.053 0.88889"
  }), _react.default.createElement("path", {
    d: "m0.63158 11.556 6.386-5.3333"
  }), _react.default.createElement("path", {
    d: "m17.053 11.556s-2.1287-1.7778-6.386-5.3333"
  }))))));
};

exports.EmailIcon = EmailIcon;

var CrossIcon = function CrossIcon(_ref6) {
  var width = _ref6.width;
  return _react.default.createElement("svg", {
    version: "1.1",
    viewBox: "0 0 16 17",
    style: {
      width: width,
      cursor: 'pointer'
    },
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, _react.default.createElement("g", {
    transform: "translate(-825 -239)",
    stroke: "#A0A0A0"
  }, _react.default.createElement("g", {
    transform: "translate(826 240)"
  }, _react.default.createElement("g", {
    strokeWidth: "2.1447"
  }, _react.default.createElement("path", {
    d: "m0.45455 0.75862 13.091 13.241"
  }), _react.default.createElement("path", {
    d: "m13.545 0.75862-13.091 13.241"
  }))))));
};

exports.CrossIcon = CrossIcon;